export const FORTA_BLUE = {
  primary: '#124E78',
  medium: '#5285A7',
  light1: '#6D91AA',
  light2: '#B0C2CF',
  light3: '#E7EDF1',
  lightest: '#F2FAFF',
  bright: '#48A2F4',
  dark: '#073B4C',
};

export const FORTA_WHITE = '#fff';
export const FORTA_BLACK = '#000';

export const FORTA_GRAY1 = '#F5F5F5';
export const FORTA_GRAY2 = '#D9D9D9';
export const FORTA_GRAY3 = '#95999C';
export const FORTA_GRAY4 = '#303030';
export const FORTA_GRAY5 = '#585A5B';
export const FORTA_GRAY6 = '#DCDCDC';
export const FORTA_GRAY7 = '#6D6F71';
export const FORTA_GRAY8 = '#767676';
export const FORTA_GRAY9 = '#4A4A4A';
export const FORTA_GRAY10 = '#BEC4C8';
export const FORTA_GRAY11 = '#AEABAB';
export const FORTA_GRAY12 = '#F7F7F7';

export const FORTA_ERROR = '#F44848';
export const FORTA_ERROR_2 = '#FBB2B2';
export const FORTA_ERROR_3 = '#F7F3F2';

export const FORTA_SUCCESS = '#7EC665';
export const FORTA_SUCCESS_2 = '#E3F3DD';
export const FORTA_SUCCESS_3 = '#F2FAEF';

export const FORTA_SKY_BLUE = '#2378d1';
export const FORTA_SKY_BLUE_2 = '#CBE0F6';
export const FORTA_SKY_BLUE_3 = '#EEF5fC';
export const FORTA_SKY_BLUE_4 = '#7CADDF66';
export const FORTA_SKY_BLUE_5 = '#C5E2F666';

export const FORTA_PINK = '#C350E2';

export const FORTA_BROWN = '#854D0E';

export const FORTA_YELLOW = '#F3D222';
export const FORTA_YELLOW_2 = '#FCF4C5';
export const FORTA_YELLOW_3 = '#FEFBEC';

export const FORTA_ORANGE = '#EFA00B';
export const FORTA_ORANGE_2 = '#F9CF80';
export const FORTA_ORANGE_3 = '#FEEFE6';

export const FORTA_PURPLE = '#571F4E';

export const FORTA_DOCS = {
  SN_53: FORTA_SUCCESS, //Session Note 97153
  BTSN: FORTA_YELLOW, //BT Supervision
  CSN_55: FORTA_BLUE.bright, // Client Supervison 97155
  PSN_56: FORTA_PINK, //Parent Supervision 97156
  GPSN_57: '#8EECF5', //Group Parent Supervision 97157
  AN_51: '#F87100', //Assessment Note 97151
  AN_52: '#F1C0E8', //Assessment Note 97152
  TP: FORTA_BLUE.primary, //Treatment plan
};
